import { Injectable } from '@angular/core';

import { PlessHttp } from '../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from './pless-dialog-service-sub';
import { PlessAlert } from '../../shared/pless-alert/pless-alert.component';
import { PlessJsonResponder } from 'src/app/shared/http/pless-json-responder.service';
import { PlessResponse } from 'src/app/shared/vo/pless-response.model';
import { PlessResponseStringHook } from './pless-response-string-hoook';

/**
 * APIと通信する際に使用するResponderの拡張クラス
 * APIと通信するサービスは基本的にこのクラスを継承する
 *
 * @template T レスポンスのresult.objのobjの型
 */
@Injectable()
export abstract class PlessJsonResponderSub<T> extends PlessJsonResponder<T> {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService, new PlessResponseStringHook<T>());
  }


  /**
   * StatusがOK以外の場合の処理
   * 独自のステータス処理を実装したい場合はこのメソッドをオーバーライドする
   *
   * @param status statauタグの値
   * @param result レスポンスの内容(rspタグの値)
   */
  protected statusError(status: string, result: PlessResponse<T>) {
    switch (status.toLowerCase()) {
      case 'plesserror':
        this.plessErrorHandler(result);
        break;
      case 'systemerror':
        this.systemErrorHandler(result);
        break;
      case 'lockfailer':
        this.lockErrorHandler(result);
        break;
      default:
        super.statusError(status, result);
        break;
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  plessErrorHandler(errList: any): void {
    // エラーコード
    const errCode: string = errList.errorcode;
    // 引数
    const msgArray: Array<string> = errList.strings;

    if (errCode === 'S0103') {
      this.dialogService.openAlertGetMessage(errCode, msgArray, () => {
        window.location.reload();
      });
      return;
    }

    // エラーメッセージ表示
    this.dialogService.openAlertGetMessage(errCode, msgArray);

  }

  /**
   * システムエラー時のメソッド
   * @param data サーバ受信データ
   *  機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public systemErrorHandler(data: any): void {
    this.dialogService.openAlert(this.makeSystemErrMsg(data), 'E');
  }

  /**
   * システムエラー発生時に表示するメッセージを構築する
   * @param errRsp サーバから受信したエラーレスポンスデータ
   * @return 表示メッセージ
   *
   */
  private makeSystemErrMsg(errRsp: any): string {
    let errMsg: string = <string>'';

    if (errRsp.errorcode != null && errRsp.message != null) {
      errMsg += errMsg + errRsp.errorcode + ' ' + errRsp.message;
    }

    return errMsg;
  }

  /**
   * ロックできなかったレコードがあった場合の処理
   *
   * @param {*} result
   * @memberof PlessResponderSub
   */
  public lockErrorHandler(result: any): void {
    this.dialogService.openAlert('データのロックに失敗しました', 'E');
  }
}
